// @flow

import { memo } from 'react';
import { trackViewItem } from '../../../../utils/googleAnalytics';

import type { TSettingDetail } from '@types/setting';

export default memo(
  function ViewItemEvent({ setting }: { setting: TSettingDetail }) {
    trackViewItem(setting);

    return null;
  },
  (prevProps, nextProps) =>
    prevProps.setting.vendor_sku === nextProps.setting.vendor_sku,
);
